import React, { useContext } from 'react';
import { contextDefaultValues } from './context';

const KeyboardUserContext = React.createContext(contextDefaultValues.isKeyboardUser);

export const useKeyboardUser = (): boolean => useContext(KeyboardUserContext);

export default KeyboardUserContext;
